import { render, staticRenderFns } from "./academy_client_player.vue?vue&type=template&id=19eea5b4&scoped=true&"
import script from "./academy_client_player.vue?vue&type=script&lang=js&"
export * from "./academy_client_player.vue?vue&type=script&lang=js&"
import style0 from "./academy_client_player.vue?vue&type=style&index=0&id=19eea5b4&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19eea5b4",
  null
  
)

export default component.exports